<template>
    <v-card class="p-3 flex-fill col-6 h-100 w-100">
        <div class="d-flex justify-content-between">
            <h5>Localisation</h5>

            <div class="d-flex justify-content-between gap-10">
                <v-btn outlined class="custom-button-primary"
                       style="height: 36px;min-width: 42px;padding: 0"
                       @click="openModal"
                >
                    <v-icon>edit</v-icon>
                </v-btn>
            </div>
        </div>

        <div>
            <div class="mb-2" v-if="localisation.address">
                <v-icon class="text-primary" left>location_on</v-icon>
                <span class="mt-auto mb-auto">{{ localisation.address }}</span>
            </div>
            <div class="mb-2" v-if="localisation.commune">
                <v-icon class="text-primary" left>location_city</v-icon>
                <span class="mt-auto mb-auto">{{ localisation.commune.name }}</span>
            </div>
            <div class="mb-2" v-if="localisation.postal_code">
                <v-icon class="text-primary" left>code</v-icon>
                <span class="mt-auto mb-auto">{{ localisation.postal_code }}</span>
            </div>
            <div class="mb-2" v-if="localisation.province">
                <v-icon class="text-primary" left>flag</v-icon>
                <span class="mt-auto mb-auto">{{ localisation.province }}</span>
            </div>
        </div>

        <v-dialog v-model="updateModal" persistent max-width="900px">
            <v-card>
                <v-card-title class="d-flex justify-content-between">
                    <div>
                        <span class="headline">Edition de la localisation</span>
                    </div>
                </v-card-title>
                <v-card-text>
                    <v-text-field outlined label="Adresse"
                                  v-model="localisationToEdit.address">
                    </v-text-field>

                    <v-autocomplete
                      v-model="localisationToEdit.commune"
                      :items="communes"
                      item-text="name"
                      return-object
                      :loading="loadingCommunes"
                      :search-input.sync="search"
                      no-data-text="Saisissez pour sélectionner une ville"
                      outlined
                      :label="cityWording">
                    </v-autocomplete>

                    <v-text-field outlined label="Code postal"
                                  v-model="localisationToEdit.postal_code">
                    </v-text-field>

                    <v-text-field outlined label="Province"
                                  v-model="localisationToEdit.province">
                    </v-text-field>

                    <div class="d-flex justify-content-end gap-10 mt-5">
                        <v-btn @click="updateModal = false">Annuler</v-btn>
                        <v-btn class="default-button custom-button-primary" @click="updateLocalisation">
                            Modifier
                        </v-btn>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-card>
</template>

<script>
import _ from "lodash"
import { mapState } from "vuex"

export default {
    name: "LocalisationBloc",
    props: [
        "localisation",
    ],
    data() {
        return {
            updateModal: false,
            localisationToEdit: {
                address: null,
                commune: null,
                postal_code: null,
                province: null,
            },
            loadingCommunes: false,
            communes: [],
            cityWording: "Commune",
            searchCommunes: null,
        }
    },
    methods: {
        openModal() {
            this.localisationToEdit = JSON.parse(JSON.stringify(this.localisation))

            if (this.localisationToEdit.commune !== null) {
                this.pushCommune(this.localisationToEdit.commune)
                this.searchCommunes = this.localisationToEdit.commune.name
            }

            this.updateModal = true
        },
        getCommunes: _.debounce(function() {
            this.loadingCommunes = true

            let payload = {
                search: this.searchCommunes,
                accountId: this.account.id,
            }

            this.$http.post("resource/communes", payload).then(res => {
                this.communes = res.body.data.communes
                this.loadingCommunes = false
            })
        }, 500),
        pushCommune(commune) {
            this.communes.push(commune)
        },
        updateLocalisation() {
            let payload = {
                localisationId: this.localisationToEdit.id,
                address: this.localisationToEdit.address,
                communeId: this.localisationToEdit.commune.id,
                postalCode: this.localisationToEdit.postal_code,
                province: this.localisationToEdit.province,
            }

            this.$http.put("auth/sit-entity/update-localisation", payload).then(res => {
                this.updateModal = false

                this.$global.$emit("reload-entity")
            })
        },
    },
    watch: {
        searchCommunes() {
            if (this.searchCommunes) {
                this.searchCommunes = this.searchCommunes.toUpperCase()
            } else {
                this.searchCommunes = null
                this.localisationToEdit.commune = null
            }

            this.getCommunes()
        },
    },
    mounted() {
        if (this.localisationToEdit.commune !== null) {
            this.pushCommune(this.localisationToEdit.commune)
            this.searchCommunes = this.localisationToEdit.commune.name
        }
    },
    computed: {
        ...mapState("account", ["account"]),
        search: {
            get() {
                return this.searchCommunes
            },

            set(searchInput) {
                this.searchCommunes = searchInput
            },
        },
    },
    created() {
        if (this.account.tis_type.code === "DAHUB_QUEBEC") {
            this.cityWording = "Municipalité"
        }
    },
}
</script>